import { render, staticRenderFns } from "./TaskResultsTable.vue?vue&type=template&id=1565d402&scoped=true"
import script from "./TaskResultsTable.vue?vue&type=script&lang=ts"
export * from "./TaskResultsTable.vue?vue&type=script&lang=ts"
import style0 from "./TaskResultsTable.vue?vue&type=style&index=0&id=1565d402&prod&scoped=true&lang=css"
import style1 from "./TaskResultsTable.vue?vue&type=style&index=1&id=1565d402&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1565d402",
  null
  
)

export default component.exports